import React, { Component } from 'react';
import {descRealisations} from '../../models/constantes'
import '../../App.css';
import { StyleSheet, css } from 'aphrodite';
import Reveal from 'react-reveal/Reveal';
import {styles} from '../common/animation';

class Realisations extends Component {

    onClickPlayStore() {
        console.log('cool')
    }

    renderElements = (props) => {
        return this.props.projects.map((el, i) => {
            let imgUrl = "imgApp_"+i+".png";
            let animation = i % 2 === 0 ? css(styles.fadeInLeft) : css(styles.fadeInRight) ;
            return ( 
                <Reveal effect={animation} duration={1500} key={i}>
                    <li  className="portfolio_project">
                        <img src={require('../../images/' + imgUrl)} className="portfolio_project-image"/>
                        <div className="portfolio_project-details">
                            <h4 className="portfolio_project-title">{descRealisations[i].name}</h4>
                            <p className="portfolio_project-description">{descRealisations[i].desc}</p>
                            <p className="portfolio_project-stack-title"><b>Stack Technique </b>: </p>
                            <div className="portfolio_project-stack">{descRealisations[i].stack.map(el => <p className="portfolio_project-stack-element" key={el}>{el}</p>)}</div>
                            <div className="portfolio_project-sources">
                                <a href={descRealisations[i].gitlab} target="_blank" className="portfolio_button">code source</a>
                                <a href={descRealisations[i].expo} target="_blank" className="portfolio_button">exécutable</a>
                                {descRealisations[i].PlayStore && 
                                <a href={descRealisations[i].PlayStore} target="_blank" className="portfolio_button--animation">
                                    <img 
                                    src={require('../../images/playstore.png')} 
                                    alt="playstore" 
                                    style={{ 
                                        height: 'auto',
                                        width: '150px'
                                    }}
                                    />
                                </a>}
                            </div>
                        </div>
                    </li>
                </Reveal>
            )
        });
    }

    render() {
        return (
            <div className="screen">
                    <Reveal effect={css(styles.fadeIn)} duration={2000}>
                        <h3 className="screen_title">Réalisations</h3>
                        <p className="screen_description"> 
                        {`Vous trouveriez ci-dessous un panel d'applications que j'ai dévéloppé 
                        pour mettre en pratique les compétences que j'ai acquises tout au long de ma formation.`}    
                        </p>
                        <hr className="screen_underline"/>
                    </Reveal>

                    <ul className="wraped_list">
                    {this.renderElements()}
                    </ul>
            </div>
        );
    }
}

export default Realisations;



// WEBPACK FOOTER //
// ./src/components/containers/Realisations.js